// extracted by mini-css-extract-plugin
module.exports = {"inputColor":"inputColor--3ssxV","color":"color--2A6Ux"};